<template>
	<App title="Stock List">
		<Block>
			<template #header>
				<h3 class="block-title">Stocks</h3>
			</template>
			<Datatable :options="options" :scopes="scope"/>
		</Block>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {

	scope = ['engine', 'battery'];
	
	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push({
			extend: 'create',
			attr: {
				href: this.route('stock.page.create'),
			},
		})
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []

		columns.push({
			data: 'serial',
			title: 'Serial Number',
		})
		
		columns.push({
			data: 'warehouse.title',
			title: 'Assigned Warehouse',
			orderable: true,
			name: 'warehouse',
			
		})
		columns.push({
			data: 'type',
			title: 'Type',
			orderable: true,
			name:'type',
		})
		

		columns.push({
			data: 'created_at',
			title: 'Registered',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		columns.push(Column.actions(this.$gate,{view:false}))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route('stock.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
		}
	}
}
export default toNative(Group)
</script>
